import { ArrowLeft, ShopIcon } from "@assets/svg";

import { ERoutes } from "@utils/constants";

import { DropdownNavItem } from "./types";

export const freeUseNavItems: DropdownNavItem[] = [
  { route: ERoutes.CatalogLandingFreeBackground, key: "freeBgMusic" },
  { route: ERoutes.FreeUseTerms, key: "freeUseSubitem" },
  { route: ERoutes.Test, key: "freeUseOrLicense" },
];

export const licensingNavItems: DropdownNavItem[] = [
  { route: ERoutes.CatalogLandingLicensing, key: "generalLicensing" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "ytCreatorProgram" },
];

export const contactNavItems: DropdownNavItem[] = [
  { route: ERoutes.Contact, key: "contactFormular" },
  { route: ERoutes.Licensing, key: "licenseReq" },
  { route: ERoutes.Submit, key: "submitMusic" },
];

export const dropdownNavItems = [
  { items: freeUseNavItems, key: "Free Use" },
  { items: licensingNavItems, key: "licensing" },
  { items: contactNavItems, key: "contacts" },
];

export const userMenuNavItems = [
  { route: ERoutes.Deals, key: "bestDeals" },
  { route: ERoutes.DownloadInstruction, key: "downloadInstructions" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "ytCreatorProgram" },
];

export const catalogItemsDesktop = [{ route: ERoutes.Catalog, key: "Browse Music" }];
export const catalogItemsMobile = [];

export const searchItemsDesktop = [{ route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> }];
export const searchItemsMobile = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.Search, key: "Search" },
];

export const trackItemsDesktop = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];
export const trackItemsMobile = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];

export const albumItemsDesktop = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];
export const albumItemsMobile = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];

export const contactUsItemsDesktop = [
  { route: ERoutes.Contact, key: "General" },
  { route: ERoutes.Licensing, key: "License Request" },
  { route: ERoutes.Submit, key: "Submit Music" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];
export const contactUsItemsMobile = [
  { route: ERoutes.Contact, key: "General" },
  { route: ERoutes.Licensing, key: "License" },
  { route: ERoutes.Submit, key: "Submit" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator" },
];

export const freeBackgroundMusicItemsDesktop = [
  { route: ERoutes.Catalog, key: "Free Music" },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];
export const freeBackgroundMusicItemsMobile = [
  { route: ERoutes.Catalog, key: "Free Music" },
  { route: ERoutes.FreeUseTerms, key: "Terms" },
  { route: ERoutes.Test, key: "Free Use Test" },
];

export const musicLicensingItemsDesktop = [
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];
export const musicLicensingItemsMobile = [
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];

export const freeUseTermsItemsDesktop = [
  { route: ERoutes.Catalog, key: "Browse Music" },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];
export const freeUseTermsItemsMobile = [
  { route: ERoutes.Catalog, key: "Music" },
  { route: ERoutes.FreeUseTerms, key: "Terms" },
  { route: ERoutes.Test, key: "Free Use Test" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
];

export const creatorProgramItemsDesktop = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];
export const creatorProgramItemsMobile = [
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
  { route: ERoutes.Test, key: "Free Use Test" },
];

export const licenseRequestItemsDesktop = [
  { route: ERoutes.Contact, key: "General" },
  { route: ERoutes.Licensing, key: "License Request" },
  { route: ERoutes.Submit, key: "Submit Music" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];
export const licenseRequestItemsMobile = [
  { route: ERoutes.Contact, key: "General" },
  { route: ERoutes.Licensing, key: "License" },
  { route: ERoutes.Submit, key: "Submit" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator" },
];

export const submitItemsDesktop = [
  { route: ERoutes.Contact, key: "General" },
  { route: ERoutes.Licensing, key: "License Request" },
  { route: ERoutes.Submit, key: "Submit Music" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];
export const submitItemsMobile = [
  { route: ERoutes.Contact, key: "General" },
  { route: ERoutes.Licensing, key: "License" },
  { route: ERoutes.Submit, key: "Submit" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator" },
];

export const dealsItemsDesktop = [
  { route: ERoutes.Deals, key: "Deals" },
  { route: ERoutes.Shop, key: "Shop", icon: <ShopIcon />, target: "_blank" },
];
export const dealsItemsMobile = [
  { route: ERoutes.Deals, key: "Deals" },
  { route: ERoutes.Shop, key: "Shop", icon: <ShopIcon />, target: "_blank" },
];

export const downloadItemsDesktop = [{ route: ERoutes.DownloadInstruction, key: "Download Instructions" }];
export const downloadItemsMobile = [{ route: ERoutes.DownloadInstruction, key: "Download Instructions" }];

export const newsletterItemsDesktop = [{ route: ERoutes.Newsletter, key: "Newsletter" }];
export const newsletterItemsMobile = [];

export const favoritesItemsDesktop = [
  { route: ERoutes.Catalog, key: "Browse Music", icon: <ArrowLeft /> },
  { route: ERoutes.FreeUseTerms, key: "Free Use Terms" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
  { route: ERoutes.MUSIC_CREATOR_PROGRAM, key: "Music Creator Program" },
];
export const favoritesItemsMobile = [
  { route: ERoutes.Catalog, key: "Music", icon: <ArrowLeft /> },
  { route: ERoutes.FreeUseTerms, key: "Terms" },
  { route: ERoutes.CatalogLandingLicensing, key: "Licensing" },
  { route: ERoutes.Test, key: "Free Use Test" },
];

export const profileItemsDesktop = [];
export const profileItemsMobile = [];

export const termsItemsDesktop = [
  { route: ERoutes.Conditions, key: "Terms & Conditions" },
  { route: ERoutes.Privacy, key: "Privacy Policy" },
  { route: "", key: "Cookies" },
];
export const termsItemsMobile = [
  { route: ERoutes.Conditions, key: "Terms of use" },
  { route: ERoutes.Privacy, key: "Privacy Policy" },
  { route: "", key: "Cookies" },
];

export const privacyItemsDesktop = [
  { route: ERoutes.Conditions, key: "Terms & Conditions" },
  { route: ERoutes.Privacy, key: "Privacy Policy" },
  { route: "", key: "Cookies" },
];
export const privacyItemsMobile = [
  { route: ERoutes.Conditions, key: "Terms of use" },
  { route: ERoutes.Privacy, key: "Privacy Policy" },
  { route: "", key: "Cookies" },
];

export const navTabsDesktop = {
  [ERoutes.Home]: [],
  [ERoutes.Catalog]: catalogItemsDesktop,

  [ERoutes.Search]: searchItemsDesktop,
  [ERoutes.TrackForMapping]: trackItemsDesktop,
  [ERoutes.AlbumForMapping]: albumItemsDesktop,
  [ERoutes.Contact]: contactUsItemsDesktop,
  [ERoutes.CatalogLandingFreeBackground]: freeBackgroundMusicItemsDesktop,
  [ERoutes.CatalogLandingLicensing]: musicLicensingItemsDesktop,
  [ERoutes.FreeUseTerms]: freeUseTermsItemsDesktop,
  [ERoutes.MUSIC_CREATOR_PROGRAM]: creatorProgramItemsDesktop,
  [ERoutes.Licensing]: licenseRequestItemsDesktop,
  [ERoutes.Submit]: submitItemsDesktop,
  [ERoutes.Deals]: dealsItemsDesktop,
  [ERoutes.DownloadInstruction]: downloadItemsDesktop,
  [ERoutes.Newsletter]: newsletterItemsDesktop,
  [ERoutes.Favorites]: favoritesItemsDesktop,
  [ERoutes.Profile]: profileItemsDesktop,
  [ERoutes.Conditions]: termsItemsDesktop,
  [ERoutes.Privacy]: privacyItemsDesktop,
};

export const navTabsMobile = {
  [ERoutes.Home]: [],
  [ERoutes.Catalog]: catalogItemsMobile,

  [ERoutes.Search]: searchItemsMobile,
  [ERoutes.TrackForMapping]: trackItemsMobile,
  [ERoutes.AlbumForMapping]: albumItemsMobile,
  [ERoutes.Contact]: contactUsItemsMobile,
  [ERoutes.CatalogLandingFreeBackground]: freeBackgroundMusicItemsMobile,
  [ERoutes.CatalogLandingLicensing]: musicLicensingItemsMobile,
  [ERoutes.FreeUseTerms]: freeUseTermsItemsMobile,
  [ERoutes.MUSIC_CREATOR_PROGRAM]: creatorProgramItemsMobile,
  [ERoutes.Licensing]: licenseRequestItemsMobile,
  [ERoutes.Submit]: submitItemsMobile,
  [ERoutes.Deals]: dealsItemsMobile,
  [ERoutes.DownloadInstruction]: downloadItemsMobile,
  [ERoutes.Newsletter]: newsletterItemsMobile,
  [ERoutes.Favorites]: favoritesItemsMobile,
  [ERoutes.Profile]: profileItemsMobile,
  [ERoutes.Conditions]: termsItemsMobile,
  [ERoutes.Privacy]: privacyItemsMobile,
};
